<div
  class="container"
  [class.container--desktop]="screenType() !== 'mobile'"
  [class.variant-b]="layoutVariant() === 'variantB'"
  [class.is-loading]="!variantLoaded()">

  <!-- Template reutilizável para listas de features do layout clássico (Control) -->
  <ng-template #classicInfoList let-mobile="mobile">
  <div class="infos" [ngClass]="{ 'infos--mobile': mobile }">
      @for (feature of currentLayoutVariant.features; track $index) {
        <div class="info">
          <div class="circle">
            @if ($index === 0) {
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <mask
                  id="mask0_headset"
                  style="mask-type: alpha"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="16"
                  height="16">
                  <rect width="16" height="16" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_headset)">
                  <path
                    d="M7.3335 14V12.6667H12.6668V7.93333C12.6668 6.63333 12.2141 5.53056 11.3085 4.625C10.4029 3.71944 9.30016 3.26667 8.00016 3.26667C6.70016 3.26667 5.59738 3.71944 4.69183 4.625C3.78627 5.53056 3.3335 6.63333 3.3335 7.93333V12H2.66683C2.30016 12 1.98627 11.8694 1.72516 11.6083C1.46405 11.3472 1.3335 11.0333 1.3335 10.6667V9.33333C1.3335 9.1 1.39183 8.88056 1.5085 8.675C1.62516 8.46944 1.78905 8.30556 2.00016 8.18333L2.05016 7.3C2.13905 6.54444 2.3585 5.84444 2.7085 5.2C3.0585 4.55556 3.49738 3.99444 4.02516 3.51667C4.55294 3.03889 5.1585 2.66667 5.84183 2.4C6.52516 2.13333 7.24461 2 8.00016 2C8.75572 2 9.47238 2.13333 10.1502 2.4C10.8279 2.66667 11.4335 3.03611 11.9668 3.50833C12.5002 3.98056 12.9391 4.53889 13.2835 5.18333C13.6279 5.82778 13.8502 6.52778 13.9502 7.28333L14.0002 8.15C14.2113 8.25 14.3752 8.4 14.4918 8.6C14.6085 8.8 14.6668 9.01111 14.6668 9.23333V10.7667C14.6668 10.9889 14.6085 11.2 14.4918 11.4C14.3752 11.6 14.2113 11.75 14.0002 11.85V12.6667C14.0002 13.0333 13.8696 13.3472 13.6085 13.6083C13.3474 13.8694 13.0335 14 12.6668 14H7.3335ZM6.00016 9.33333C5.81127 9.33333 5.65294 9.26944 5.52516 9.14167C5.39738 9.01389 5.3335 8.85556 5.3335 8.66667C5.3335 8.47778 5.39738 8.31944 5.52516 8.19167C5.65294 8.06389 5.81127 8 6.00016 8C6.18905 8 6.34738 8.06389 6.47516 8.19167C6.60294 8.31944 6.66683 8.47778 6.66683 8.66667C6.66683 8.85556 6.60294 9.01389 6.47516 9.14167C6.34738 9.26944 6.18905 9.33333 6.00016 9.33333ZM10.0002 9.33333C9.81127 9.33333 9.65294 9.26944 9.52516 9.14167C9.39738 9.01389 9.3335 8.85556 9.3335 8.66667C9.3335 8.47778 9.39738 8.31944 9.52516 8.19167C9.65294 8.06389 9.81127 8 10.0002 8C10.1891 8 10.3474 8.06389 10.4752 8.19167C10.6029 8.31944 10.6668 8.47778 10.6668 8.66667C10.6668 8.85556 10.6029 9.01389 10.4752 9.14167C10.3474 9.26944 10.1891 9.33333 10.0002 9.33333ZM4.01683 8.3C3.93905 7.12222 4.29461 6.11111 5.0835 5.26667C5.87238 4.42222 6.85572 4 8.0335 4C9.02238 4 9.89183 4.31389 10.6418 4.94167C11.3918 5.56944 11.8446 6.37222 12.0002 7.35C10.9891 7.33889 10.0585 7.06667 9.2085 6.53333C8.3585 6 7.70572 5.27778 7.25016 4.36667C7.07238 5.25556 6.69738 6.04722 6.12516 6.74167C5.55294 7.43611 4.85016 7.95556 4.01683 8.3Z"
                    fill="#0098FC" />
                </g>
              </svg>
            } @else if ($index === 1) {
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M1.3335 4.66671C1.3335 4.31309 1.47397 3.97395 1.72402 3.7239C1.97407 3.47385 2.31321 3.33337 2.66683 3.33337H13.3335C13.6871 3.33337 14.0263 3.47385 14.2763 3.7239C14.5264 3.97395 14.6668 4.31309 14.6668 4.66671V11.3334C14.6668 11.687 14.5264 12.0261 14.2763 12.2762C14.0263 12.5262 13.6871 12.6667 13.3335 12.6667H2.66683C2.31321 12.6667 1.97407 12.5262 1.72402 12.2762C1.47397 12.0261 1.3335 11.687 1.3335 11.3334V4.66671Z"
                  stroke="#0098FC"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                  stroke="#0098FC"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M1.3335 6.00004C2.04074 6.00004 2.71902 5.71909 3.21911 5.21899C3.71921 4.7189 4.00016 4.04062 4.00016 3.33337M12.0002 12.6667C12.0002 11.9595 12.2811 11.2812 12.7812 10.7811C13.2813 10.281 13.9596 10 14.6668 10"
                  stroke="#0098FC"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            } @else {
              <anota-icon iconName="clock" iconColor="#0098FC" iconSize="16px"></anota-icon>
            }
          </div>
          <p class="text-info">
            {{ feature }}
          </p>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #warningItems>
    <span>
      @for (item of warningBannerItems(); track $index) {
        <anota-icon
          [iconName]="item.icon"
          [iconColor]="item.iconColor"
          [iconSize]="item.iconSize">
        </anota-icon>
        {{ item.text }}
      }
    </span>
  </ng-template>

  @if (layoutVariant() === 'variantB') {
    <div class="variant-b-header">
      <div class="header-content">
        <div class="anota-logo">
          <img [src]="screenType() === 'mobile' ? '../../../../../assets/logo-anota-ai-white.svg' : '../../../../../assets/logo-text.svg'" alt="Anota AI" class="logo-icon" />
        </div>
        <div class="header-pill">
          <anota-icon iconName="clock" iconColor="#353434" iconSize="16px"></anota-icon>
          <span>
            @if (offersRemaining() === 1) {
              {{screenType() === 'mobile' ? 'Resta apenas 1 oferta' : 'Resta apenas 1 oferta com desconto'}}
            } @else {
              {{screenType() === 'mobile' ? 'Restam apenas ' + offersRemaining() + ' ofertas' : 'Restam apenas ' + offersRemaining() + ' ofertas com desconto'}}
            }
          </span>
        </div>
      </div>
    </div>
  }

  <!-- Desktop Variants -->
    @if (layoutVariant() === 'variantB') {
      <!-- Variant B Desktop -->
      <div class="variant-b-background-container">
        <div class="content variant-b-desktop">
          <div class="offer">
            <h1 class="hero-title-desktop">
              Tudo que você precisa para
              <span class="highlight-blue">automatizar, crescer e lucrar</span>
              mais...
            </h1>

            <div class="price-ribbon-desktop">
              <div class="ribbon-inner">
                <span class="price-label">De</span>
                <span class="price-from">{{ currentLayoutVariant.originalPrice }}</span>
                <span class="price-label">Por</span>
                <span class="price-current">
                  {{ priceParts().units }}<span class="price-decimal">,{{ priceParts().cents }}</span>
                </span>
                <span class="price-period">
                  @if (screenType() === 'mobile') {
                    nos 3 primeiros<br>meses
                  } @else {
                    {{ currentLayoutVariant.period }}
                  }
                  {{ currentLayoutVariant.method }}
                </span>
              </div>
            </div>
          </div>

          <div class="cta-buttons">
            <anota-button
              class="cta-button-hero-b"
              [disabled]="isLoading()"
              (click)="hire()">
              @if (isLoading()) {
                <div class="loading-content">
                  <div class="spinner"></div>
                  <span>Estamos preparando sua oferta...</span>
                </div>
              } @else {
                {{ currentLayoutVariant.ctaText }}
              }
            </anota-button>

            <anota-button
              class="cta-button-hero-b"
              type="secondary"
              (click)="try()">
              {{ currentLayoutVariant.alternativeText }}
            </anota-button>
          </div>


          <div class="features-pills-desktop">
            @if (screenType() === 'mobile') {
              <!-- Mobile: 2 colunas de 3 linhas cada -->
              <div class="features-mobile-grid">
                <div class="features-column">
                  @for (feature of currentLayoutVariant.features.slice(0, 3); track $index) {
                    <div class="pill-mobile">
                      <div class="pill-icon-mobile">
                        <anota-icon
                          iconName="crown"
                          iconColor="#0098FC"
                          iconSize="16px"></anota-icon>
                      </div>
                      <span class="pill-text-mobile">{{ feature }}</span>
                    </div>
                  }
                </div>
                <div class="features-column">
                  @for (feature of currentLayoutVariant.features.slice(3, 6); track $index) {
                    <div class="pill-mobile">
                      <div class="pill-icon-mobile">
                        <anota-icon
                          iconName="crown"
                          iconColor="#0098FC"
                          iconSize="16px"></anota-icon>
                      </div>
                      <span class="pill-text-mobile">{{ feature }}</span>
                    </div>
                  }
                </div>
              </div>
              <div class="pill-mobile pill-extra">
                <div class="pill-icon-mobile inverse">
                  <anota-icon
                    iconName="plus"
                    iconColor="#FFFFFF"
                    iconSize="16px"></anota-icon>
                </div>
                <span class="pill-text-mobile">{{ currentLayoutVariant.features[6] }}</span>
              </div>
            } @else {
              <!-- Desktop: layout horizontal -->
              @for (feature of currentLayoutVariant.features; track $index) {
                <div class="pill">
                  <div class="pill-icon" [class.inverse]="feature?.toLowerCase()?.includes('muito mais')">
                    <anota-icon
                      [iconName]="feature?.toLowerCase()?.includes('muito mais') ? 'plus' : 'crown'"
                      [iconColor]="feature?.toLowerCase()?.includes('muito mais') ? '#FFFFFF' : '#0098FC'"
                      iconSize="16px"></anota-icon>
                  </div>
                  <span class="pill-text">{{ feature }}</span>
                </div>
              }
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="banner-offer variant-control" [class.last-days]="offersActivated()">
        <div class="warning-banner top" [class.last-days]="offersActivated()">
          <div class="warning-content">
            <ng-container [ngTemplateOutlet]="warningItems"></ng-container>
          </div>
        </div>

        <div class="banner-offer-content">
          <div class="offer-container">
           <img class="anota-logo" src='../../../../../assets/logo-text-white.svg' alt="Anota AI" />

            <div class="price-container">
              <div class="price-section">
                <div class="price-label-container">
                  <div class="currency-title">Por apenas</div>
                    <span class="currency">R$</span>
                  </div>

                  <div class="price-wrapper">
                    <span class="price">{{ priceParts().units }}</span>
                    <span span class="price-cents">,{{ priceParts().cents }}</span>
                  </div>
              </div>

              <div class="subtitle">* {{ currentLayoutVariant.period }}</div>
            </div>
          </div>

          <img class="banner-image" src="../../../../../assets/airton-holding-phone.svg" alt="Airton segurando o celular" />
        </div>

        <div class="warning-banner bottom" [class.last-days]="offersActivated()">
          <div class="warning-content">
            <ng-container [ngTemplateOutlet]="warningItems"></ng-container>
          </div>
        </div>
      </div>

      <div class="content" [class.content--mobile]="screenType() === 'mobile'">
        @if (offersActivated()) {
          <h2 class="offer-title">Contrate agora e aproveite a oferta antes da mudança de valores!</h2>
        }
        <div class="banner" [class.banner--mobile]="screenType() === 'mobile'">
          @if (offersActivated()) {
            <div class="savings-badge">
              <p class="text">Economize até 🔥 <br> {{ currentLayoutVariant.savedAmount }}</p>
            </div>
          } @else {
            <div class="badge">
              <p class="text">{{ currentLayoutVariant.discount }}</p>
            </div>
          }
          <div class="price">
            <p class="old-price">{{ currentLayoutVariant.originalPrice }}</p>
            <p class="new-price">{{ currentLayoutVariant.newPrice }}</p>
            <p class="month">{{ currentLayoutVariant.period }}</p>
            <p class="month">{{ currentLayoutVariant.method }}</p>
          </div>
        </div>
        <ng-container
          [ngTemplateOutlet]="classicInfoList"
          [ngTemplateOutletContext]="{ mobile: true }"></ng-container>
        <div class="container-buttons" [class.container-buttons--mobile]="screenType() === 'mobile'">
          <anota-button
            class="button"
            [disabled]="isLoading()"
            (click)="hire()">
            @if (isLoading()) {
              <div class="loading-content">
                <div class="spinner"></div>
                <span>Estamos preparando sua oferta...</span>
              </div>
            } @else {
              {{ currentLayoutVariant.ctaText }}
            }
          </anota-button>
        </div>
        <p class="continue" (click)="try()">{{ currentLayoutVariant.alternativeText }}</p>
      </div>
    }
</div>

<app-middleware-exit-intent-modal
  [visible]="showExitIntentModal()"
  variant="variantB"
  [dealId]="deal_id"
  (onAccept)="onExitIntentAccept()"
  (onDismiss)="onExitIntentDismiss()"
  (visibleChange)="showExitIntentModal.set($event)"></app-middleware-exit-intent-modal>
